import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Template from './template';
import { UserApproveCheck } from 'components';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import { apiGetUserProfile } from 'api/ZimssaAPI';
import { useApiRequest } from 'hooks';
import { getPhoneWithHyphen, getBirthdayWithDot, isSameServiceType } from 'commons/ZimssaHelper';

function UserApproveCheckView(): React.ReactElement {
    const history = useHistory();
    const partnerAuthState = useContext(PartnerAuthState);
    const { serviceType, partnerUserIdx } = useParams<{ serviceType: string, partnerUserIdx: string }>();
    const serviceIdx = partnerAuthState.service.find((item) => isSameServiceType(item.serviceType, serviceType))?.serviceIdx;
    const [fetchResult, fetchProfile] = useApiRequest<any>(apiGetUserProfile);
    const [userProfile, setUserProfile] = useState<IUserRegisterForm>(defaultFormState);

    useEffect(() => {
        if (serviceIdx && serviceType && partnerUserIdx) {
            fetchProfile({
                type: 'REQUEST',
                body: [partnerUserIdx, serviceType, serviceIdx],
            });
        }
    }, [fetchProfile, partnerUserIdx, serviceIdx, serviceType]);

    useEffect(() => {
        const { result, data } = fetchResult;
        if (result === 'success' && data) {
            const responseData: {
                partnerUserIdx: number;
                partnerUserDocStatus: string;
                partnerUserActiveStatus: string;
                name: string;
                phone: string;
                birthday: string;
            } = data;

            if (responseData.partnerUserActiveStatus === 'sign_up' && responseData.partnerUserDocStatus === 'approve_check') {
                setUserProfile({
                    name: responseData.name,
                    phone: responseData.phone,
                    birthday: responseData.birthday,
                });
            } else {
                alert('해당 파트너 유저는 조회가 불가능한 상태입니다.');
                history.goBack();
            }
        }
    }, [fetchResult, history]);

    const userApproveCheckProps = {
        name: userProfile.name,
        phone: getPhoneWithHyphen(userProfile.phone),
        birthday: getBirthdayWithDot(userProfile.birthday),
    };

    return (
        <Template>
            <UserApproveCheck {...userApproveCheckProps} />
        </Template>
    );
}

export default UserApproveCheckView;

const defaultFormState: IUserRegisterForm = {
    name: '',
    phone: '',
    birthday: '',
};

interface IUserRegisterForm {
    name: string;
    phone: string;
    birthday: string;
}
